

import { InjectionToken } from '@angular/core';

import { WeekDayIndex } from 'mwc/core/time';

export interface MwcDateConfig {
  /** Customize the first day of a week */
  firstDayOfWeek?: WeekDayIndex;
}

export const NZ_DATE_CONFIG = new InjectionToken<MwcDateConfig>('date-config');

export const NZ_DATE_CONFIG_DEFAULT: MwcDateConfig = {
  firstDayOfWeek: undefined
};

export function mergeDateConfig(config: MwcDateConfig): MwcDateConfig {
  return { ...NZ_DATE_CONFIG_DEFAULT, ...config };
}
